"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _A11yText = _interopRequireDefault(require("../A11yText"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Box = _interopRequireDefault(require("../Box"));
var _Listbox = _interopRequireDefault(require("../Listbox"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Suggestions = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    hasResults,
    items = [],
    noResults,
    onClose,
    onSelect,
    parentRef
  } = _ref;
  const pressableItems = items.map(_ref2 => {
    let {
      id,
      ...rest
    } = _ref2;
    return {
      id,
      onPress: () => onSelect(id),
      ...rest
    };
  });
  if (items?.length) return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_A11yText.default, {
      accessibilityLiveRegion: "polite",
      text: hasResults
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Listbox.default, {
      items: pressableItems,
      firstItemRef: ref,
      parentRef: parentRef,
      onClose: onClose
    })]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    space: 3,
    children: typeof noResults === 'string' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        accessibilityLiveRegion: "polite",
        variant: {
          size: 'small'
        },
        children: noResults
      })
    }) : noResults
  });
});
Suggestions.displayName = 'Suggestions';
Suggestions.propTypes = {
  hasResults: _propTypes.default.string.isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    label: _propTypes.default.node
  })).isRequired,
  noResults: _propTypes.default.node.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onSelect: _propTypes.default.func.isRequired,
  parentRef: _propTypes.default.object.isRequired
};
var _default = exports.default = Suggestions;